import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoPolitica from "../legal/InfoPolitica";
const Footer = lazy(() => import('../footer/Footer'));
function PoliticaPrivacidad() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Bienvenido al sitio web oficial de Hyundai Ecuador. Conoce nuestra amplia gama de modelos, concesionarios y todos los servicios especialmente pensados para ti."
        />
        <meta
          name="keywords"
          content="Hyundai, Politica, Privacidad"
        />
        <title>Hyundai politicas de privacidad</title>
      </Helmet>
      <Menu />
      <InfoPolitica />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default PoliticaPrivacidad;